import { makeStyles } from '@material-ui/core';

export default makeStyles(({ breakpoints, palette: { grey }, typography: { h3, body1 } }) => ({
  back: {
    margin: '30px 0',

    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },

  message: {
    '& > *:nth-child(1)': {
      ...h3,
      fontWeight: 'bold',
      margin: '10px 0',
    },

    '& > *:nth-child(2)': {
      ...body1,
      fontSize: 15,

      '&, & *': {
        color: `${grey[500]} !important`,
      },
    },

    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}));
